import { z } from 'zod';
export const DashboardKpiSchema = z.object({
    billingThisMonthCents: z.number().int(),
    billingThisYearCents: z.number().int(),
    paidThisYearCents: z.number().int(),
    pendingTotalCents: z.number().int(),
    overduePendingCents: z.number().int(),
    activeCasesCount: z.number().int(),
    openTasksCount: z.number().int(),
    myOpenTasksCount: z.number().int(),
    deadlinesNext7d: z.number().int(),
    deadlinesNext30d: z.number().int(),
    overdueDeadlines: z.number().int(),
    unbilledTimeMinutes: z.number().int(),
    unbilledTimeAmountCents: z.number().int(),
    fundsAvailableTotalCents: z.number().int(),
});
export const MonthlyBillingPointSchema = z.object({
    /** YYYY-MM */
    month: z.string(),
    totalCents: z.number().int(),
    paidCents: z.number().int(),
    invoicesCount: z.number().int(),
});
export const MonthlyBillingResponseSchema = z.object({
    points: z.array(MonthlyBillingPointSchema),
});
export const BreakdownPointSchema = z.object({
    key: z.string(),
    label: z.string(),
    count: z.number().int(),
});
export const CasesBreakdownResponseSchema = z.object({
    byStatus: z.array(BreakdownPointSchema),
    byArea: z.array(BreakdownPointSchema),
});
export const TopClientItemSchema = z.object({
    clientId: z.string(),
    clientDisplayName: z.string(),
    totalCents: z.number().int(),
    paidCents: z.number().int(),
    invoicesCount: z.number().int(),
});
export const TopClientsResponseSchema = z.object({
    year: z.number().int(),
    items: z.array(TopClientItemSchema),
});
//# sourceMappingURL=stats.js.map